import { IconTooltip } from './TooltipCard';

/**
 * Icon-only action button with a hover tooltip; the label doubles as the aria-label.
 * className      extra button classes
 * iconClassName  extra icon classes
 */
function IconActionButton({
  label,
  icon: Icon,
  onClick,
  tooltipPosition,
  className = '-m-1',
  iconClassName = 'text-secondary-red',
  ...buttonProps
}) {
  return (
    <IconTooltip label={label} position={tooltipPosition}>
      <button
        type="button"
        className={`group p-1 border-0 bg-transparent cursor-pointer focus:outline-none ${className}`}
        aria-label={label}
        onClick={onClick}
        {...buttonProps}
      >
        <Icon
          className={`h-5 w-5 shrink-0 pointer-events-none opacity-40 group-hover:opacity-100 transition-opacity ${iconClassName}`}
          aria-hidden="true"
        />
      </button>
    </IconTooltip>
  );
}

export default IconActionButton;
